import template from './index.html'
import { fapp } from '../../fapp'

const pageCinemaEdit = () => {
  return {
    title: 'ИЗБРАННОЕ - НАСТРОЙКИ',
    showAddCameras: false,
    existsItems: [],
    refreshFlag: new Date().getTime(),
    async init() {
      if (this.$store.state.devices == null) {
        try {
          const devices = await fapp.service('/api/devices').find({ query: { $include: ['cameras'], $paginate: 'false'}})
          this.$store.state.devices = devices
        } catch(e) {
        }
      }

      this.$nextTick(_ => {
        this.$el.innerHTML = template
      })
    },
    activating() {
      this.refreshFlag = new Date().getTime()
    },
    closeDevices() {
      let cinemaItems = this.$store.state.cinemaItems

      const existsItemsSet = new Set(this.existsItems)
      cinemaItems = cinemaItems.filter(item => existsItemsSet.has(item.id))

      this.existsItems.forEach(id => {
        if (!cinemaItems.some(item => item.id === id)) {
          cinemaItems.push({ id })
        }
      })

      this.$store.state.cinemaItems = cinemaItems

      this.showAddCameras = false
    },
    showAdd() {
      this.existsItems = this.$store.state.cinemaItems.map(item => item.id)
      this.showAddCameras = true
    },
    addCamera(camera) {
      console.log(camera)
      this.existsItems.push(camera.id)
    },
    removeCamera(camera) {
      console.log(camera)
      const index = this.existsItems.indexOf(camera.id)
      if (index != -1) this.existsItems.splice(index, 1)
    },
    sizeChange(settings, value){
      settings.x2 = !value
    },
    sortItems(item, position){
      
    },
    getScheme() {
      if (window.webkit && window.webkit.messageHandlers.IOS == undefined) {
        return 'socket://com.videokot.cctv/app'
      }
      return 'x-local:/'
    }
  }
}

export { pageCinemaEdit }
